var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFornecedorPreto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fornecedor-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #000000;stroke: #000000;stroke-width: 0.4 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M47.67 21.02C47.88 21.3 48 21.66 48 22.03L48 33.23C48 34.19 47.21 34.99 46.24 34.99L43.72 34.99C42.88 37.49 40.51 39.29 37.75 39.29C34.98 39.29 32.62 37.47 31.77 34.99L17.26 34.99C16.42 37.49 14.05 39.29 11.29 39.29C8.52 39.29 6.16 37.47 5.32 34.99L1.76 34.99C0.79 34.99 0 34.19 0 33.23L0 11.22C0 10.26 0.79 9.47 1.76 9.47L32.35 9.47C33.31 9.47 34.11 10.26 34.11 11.22L34.11 14.43L42.16 14.43C42.72 14.43 43.26 14.71 43.59 15.17L43.59 15.18L47.67 21.02ZM44.53 25.55L37.42 25.55C36.46 25.55 35.66 24.75 35.66 23.79L35.66 17.95L34.11 17.95L34.11 27.86C35.14 27.12 36.41 26.68 37.76 26.68C40.73 26.68 43.21 28.73 43.89 31.5L44.53 31.5L44.53 25.55ZM3.51 31.5L5.16 31.5C5.82 28.73 8.32 26.68 11.29 26.68C14.26 26.68 16.74 28.73 17.42 31.5L30.6 31.5L30.6 13L3.51 13L3.51 31.5ZM14.09 32.98C14.09 31.43 12.83 30.18 11.29 30.18C9.74 30.18 8.49 31.43 8.49 32.98C8.49 34.52 9.74 35.78 11.29 35.78C12.83 35.78 14.09 34.52 14.09 32.98ZM40.57 32.98C40.57 31.43 39.31 30.18 37.76 30.18C36.22 30.18 34.96 31.43 34.96 32.98C34.96 34.52 36.22 35.78 37.76 35.78C39.31 35.78 40.57 34.52 40.57 32.98ZM39.19 17.95L39.19 22.03L44.14 22.03L41.26 17.95L39.19 17.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFornecedorPreto);
export default __webpack_public_path__ + "static/media/fornecedor_preto.744ed6bd44ed389fee3300a3471eadda.svg";
export { ForwardRef as ReactComponent };